import React from "react";
import CookiesContainer from "./CookiesContainer";

const Footer = () => {
  return (
    <>
      <CookiesContainer />
      <div className="footer__main">
        <p>
          Merago Inc. Mountain View, California, USA. ©2023 All rights reserved
          -v 3.0.7
        </p>
      </div>
    </>
  );
};

export default Footer;
